module.exports = __webpack_public_path__ + "staticcomp/img/cover.064cd63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/cover.jpg
// module id = eJ0X
// module chunks = 39